'use strict';

frontendApp.controller('LayerCtrl', ['$scope', 'LayerService', function($scope, LayerService) {

    $scope.layer = LayerService.getLayer();
    $scope.popLayer = LayerService.popLayer;
    
}]);
